import { environment } from './../../../environment/environment';
import { CallOfferService } from './../../core/services/call-offer-service/call-offer.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IRequstJob } from './../../core/models/call-offer';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

const DOMPurify = require('dompurify')

@Component({
  selector: 'app-details-offer',
  templateUrl: './details-offer.component.html',
  styleUrls: ['./details-offer.component.css'],
})
export class DetailsOfferComponent {
  /* object */
  esnDetails: any;
  jobRequest!: IRequstJob;
  /* string */
  //  id!: string
  /* formGroup */
  callDetailsForm: FormGroup = this.DetailsForm();
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  /* short url */
  siteweb_link: any;
  shortenedUrl = '';
  call: any;
  url: string = environment.baseUrl + '/api';
  listReviewCompany: any;
  listDefaultReview: any;
  skills1: any;

  jobofferDetails: any;
  /* number */
  totalItems!: number;
  itemsPerPage: number = 20;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  total_avg_stars: any;
  showBoxResponseCompany = false;
  showBoxDefaultResponse = true;
  id = this.activatedRoute.snapshot.params['id'];
  safeDescription!: SafeHtml;

  constructor(
    private activatedRoute: ActivatedRoute,
    private callService: CallOfferService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    window.scrollTo(0, 0);
    this.getId();
    this.getskillsjoboffer();
  }

  /* get id esn from route */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.id = params.params['id'];
        this.getCompanyById();
      },
    });
  }
 updateDescription(description: string) {
  const sanitizedHtml = DOMPurify.sanitize(description);
    this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
  }
  /* get company  details */
  getCompanyById() {
    this.spinner.show();
    this.callService
      .getcallById(this.id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('API Response:', res);
          this.jobofferDetails = res.data[0];
          this.updateDescription(this.jobofferDetails.description);
          // this.callDetailsForm = this.DetailsForm(res.data[0]);
          console.log('Form Value:', this.jobofferDetails);
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  getskillsjoboffer() {
    this.callService.getskillsjoboffre(this.id).subscribe({
      next: (res: any) => {
        this.skills1 = res.data;
        console.log('skills job offer', this.skills1);
      },
      error: (error) => {
        console.log('error', error);
      },
    });
  }
  DetailsForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name ? data.name : '', [Validators.required]],
      post_type: [
        data && data.post_type ? data.post_type : '',
        [Validators.required],
      ],
      country: [
        data && data.country ? data.country : '',
        [Validators.required],
      ],
    });
  }

  /* unsubscribe from api */
  // ngOnDestroy() {
  //   this.unsubscribeAll.next();
  //   this.unsubscribeAll.complete();
  // }
}
